import { DEFAULT_LOCALE } from '@/constants/defaultLocale.constant'

export function transformLocale({
	locale,
	to,
}: {
	locale?: string
	to: 'dato' | 'params'
}) {
	if (!locale) return DEFAULT_LOCALE

	const [firstPart, secondPart] = locale.includes('-')
		? locale.split('-')
		: locale.split('_')

	if (!secondPart) return locale

	return to === 'dato'
		? `${firstPart}_${secondPart.toUpperCase()}`
		: `${firstPart}-${secondPart.toLowerCase()}`
}

export function transformLocaleToJsonLd({ locale }: { locale?: string }) {
	if (!locale) return DEFAULT_LOCALE.toUpperCase()

	const [firstPart] = locale.includes('-')
		? locale.split('-')
		: locale.split('_')

	return firstPart.toUpperCase()
}
